<div class="alarm-container">

    <div class="loading-container">
        <loading [isLoading]="isLoading" [isFullSize]="true"></loading>
    </div>

    <div class="btnClose">
      <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="close()"></mat-icon>
    </div>

    <div class="row alarm-header">
      <div class="col-12 d-flex  alarm-header-title">
          <h1>Alarmas Activas</h1>
      </div>
      <div class="col-12 d-flex alarm-header-subtitle">
        <label> Las siguientes alarmas ocupan su atención</label>
      </div>
    </div>

    <mat-card class="row alarm-list" *ngIf="alarmList.length > 0">
      <mat-card-content>
        <div class="alarm-list-content" (scroll)="onScroll($event)">

          <div [class]="'alarm-item alarm-'+alarm.idAlarmCategory" *ngFor="let alarm of alarmList" (click)="onalarmClick(alarm)">
              <div class="col-8 alarm-item-text">
                  <div class="alarm-item-title">
                      {{alarm.date}} - {{alarm.hour}}
                  </div>
                  <div class="alarm-item-title">
                      {{alarm.alarmCategory}}
                  </div>
                </div>
              <div class="col-4 alarm-item-description">
                {{alarm.identifier}}
              </div>
            </div>
      
        </div>
      </mat-card-content>
    </mat-card>

    <div class="alarm-list" *ngIf="alarmList.length <= 0 && isalarmEnd">
      <h3 style="margin: auto; width: fit-content;">No hay alarmas activas</h3>
    </div>

    <div class="row close-button-container">
      <button class="" (click)="close()">Cerrar</button>
    </div>

  </div>